export enum ProjectSortType {
    Id,
    Name,
    IsDeleted
}
